const approvalRemarkModalInitialState = {
  approvalRemarkModal: {
    isOpened: false,
    approvalType: '',
    offerId: '',
    remark: '',

    //FIXME: this is only for some quotation & booking approval
    updatePath: '',
    approverType: '',
    approverLevel: -1,

    meta: {},
  },
}

const approvalRemarkModalReducer = {
  showApprovalRemarkModal: (state, { payload }) => {
    state.approvalRemarkModal = {
      isOpened: true,
      ...payload,
    }
  },
  hideApprovalRemarkModal: (state) => {
    state.approvalRemarkModal = {
      isOpened: false,
      approvalType: '',
      offerId: '',
      remark: '',
      approverType: '',
      approverLevel: -1,
      updatePath: '',
      meta: {},
    }
  },
}

const selectApprovalRemarkModal = (state) => state.offers.approvalRemarkModal

export { approvalRemarkModalInitialState, approvalRemarkModalReducer, selectApprovalRemarkModal }
